// extracted by mini-css-extract-plugin
export default {"popoverPaper":"EntitiesLinks_popoverPaper__ea+gO","entities":"EntitiesLinks_entities__vp-aF"};